import { addDays, getPrototypeToday } from "../prototypeDates";

export type ReturnRequestProduct = {
  id: string;
  name: string;
  color: string;
  size: string;
  imageUrl: string;
  quantity: number;
  issueLabel: string;
  reviewIssueLabel: string;
  receivedIssueLabel: string;
  selectedByDefault: boolean;
};

export const RETURN_REQUEST_BRAND_NAME = "Ro & Co";

const returnByDate = addDays(getPrototypeToday(), 10);

export const RETURN_REQUEST_RETURN_BY = returnByDate.toLocaleDateString(
  "en-US",
  {
    month: "long",
    day: "numeric",
  }
);

export const RETURN_REQUEST_PRODUCTS: ReturnRequestProduct[] = [
  {
    id: "chambray-shirt",
    name: "Chambray Shirt",
    color: "Blue",
    size: "S",
    imageUrl: "/images/ck/brand-portal-issues-page/chambray-shirt.png",
    quantity: 4,
    issueLabel: "Quality (4 of 6)",
    reviewIssueLabel: "Quality (4)",
    receivedIssueLabel: "Quality issues",
    selectedByDefault: true,
  },
  {
    id: "knit-wool-cardigan",
    name: "Knit Wool Cardigan",
    color: "Taupe",
    size: "L",
    imageUrl: "/images/ck/brand-portal-issues-page/knit-wool-cardigan.png",
    quantity: 1,
    issueLabel: "Quality (1 of 1)",
    reviewIssueLabel: "Quality (1)",
    receivedIssueLabel: "Quality issues",
    selectedByDefault: false,
  },
  {
    id: "linen-tank",
    name: "Linen Button Down Tank Top",
    color: "Black",
    size: "S",
    imageUrl:
      "/images/ck/brand-portal-issues-page/linen-button-down-tank-return.png",
    quantity: 3,
    issueLabel: "Quality (3 of 5)",
    reviewIssueLabel: "Quality (3)",
    receivedIssueLabel: "Quality issues",
    selectedByDefault: true,
  },
  {
    id: "graphic-tshirt",
    name: "Black Graphic T-shirt",
    color: "Black",
    size: "S",
    imageUrl: "/images/ck/brand-portal-issues-page/black-graphic-tshirt.png",
    quantity: 1,
    issueLabel: "Wrong item (1 of 6)",
    reviewIssueLabel: "Wrong item (1)",
    receivedIssueLabel: "Wrong item",
    selectedByDefault: true,
  },
];

export const getSelectedReturnRequestProducts = (
  selectedIds: ReadonlySet<string>
): ReturnRequestProduct[] =>
  RETURN_REQUEST_PRODUCTS.filter((product) => selectedIds.has(product.id));

export const getReturnRequestItemCount = (
  products: ReturnRequestProduct[]
): number => {
  let total = 0;

  for (const product of products) {
    total += product.quantity;
  }

  return total;
};

export const DEFAULT_RETURN_REQUEST_SELECTED_IDS = new Set(
  RETURN_REQUEST_PRODUCTS.filter((product) => product.selectedByDefault).map(
    (product) => product.id
  )
);
